//配置全局访问接口地址
let commonUrl = process.env.VUE_APP_BASE_API;

let baseUrl = {
    commonUrl
}

export default baseUrl
